import CartServices from '../../components/cart-details/cart-details.service.js'

const cartServices = new CartServices()
const cartDetails = JSON.parse(localStorage.getItem('cartDetails')) || {}

const state = {
  cartContainer: {
    products: cartDetails['products'] || {},
    itemCount: cartDetails['itemCount'] || 0,
    subtotal: cartDetails['subtotal'] || 0,
    shipping: cartDetails['shipping'] || 0,
    tax: cartDetails['tax'] || 0,
    digital: false,
    totalPrice: cartDetails['totalPrice'] || 0.00
  }
}
const getters = {
  cartDetails (state) {
    return state.cartContainer
  },
  totalItems (state) {
    if (!state.cartContainer) {
      return 0
    }
    return state.cartContainer.itemCount
  },
  products (state) {
    return (state.cartContainer || {}).products
  },
  subtotal (state) {
    return (state.cartContainer || {}).subtotal
  },
  shipping (state) {
    return (state.cartContainer || {}).shipping
  },
  tax (state) {
    return (state.cartContainer || {}).tax
  },
  digital (state) {
    return (state.cartContainer || {}).digital
  },
  totalPrice (state) {
    let totalPrice = (state.cartContainer || {}).totalPrice || 0.00
    totalPrice = parseFloat(totalPrice).toFixed(2)
    return parseFloat(totalPrice)
  }
}
const actions = {
  increment ({ commit }, { product, quantity }) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('increment', { product, quantity })
        resolve()
      }, 100)
    })
  },
  decrement ({ commit }) {
    return new Promise((resolve) => {
      setTimeout(() => {
        commit('decrement')
        resolve()
      }, 100)
    })
  }
}
const mutations = {
  increment (state, payload) {
    state.cartContainer = cartServices.updateCart(payload.product, payload.quantity, payload.product.productId)
  },

  decrement (state) {
    state.cartContainer = localStorage.setItem('cartDetails', null)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
